import { CHANGE_TAB_KEPEGAWAIAN_IPASN, DELETE_UNKER_CHOICE, GET_DETAIL_KEPEGAWAIAN_PEGAWAI, GET_LIST_KEPEGAWAIAN_PEGAWAI_IPASN, GET_LIST_KEPEGAWAIAN_PEGAWAI_PRIBADI, GET_RESULT_PEGAWAI, GET_UNKER_CHOICE, GET_UNKER_PEGAWAI, GET_SATKER_BY_UNKER } from "shared/constants/ActionTypes";

const initialState = {
    detail: null,
    listsIPASN: null,
    listsPribadi: null,
    typeIPASN: 'dashboard',
    listUnker: null,
    resultPegawai: null,
    listUnkerPegawai: null,
    listSatkerByUnker: null
};

const kepegawaianReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_UNKER_CHOICE:
            return {
                ...state,
                listUnker: action.payload
            }
        case DELETE_UNKER_CHOICE:
            return {
                ...state,
                listUnker: null
            }
        case GET_UNKER_PEGAWAI:
            return {
                ...state,
                listUnkerPegawai: action.payload
            }
        case GET_SATKER_BY_UNKER:
            return {
                ...state,
                listSatkerByUnker: action.payload
            }
        case GET_RESULT_PEGAWAI:
            return {
                ...state,
                resultPegawai: action.payload
            }
        case GET_LIST_KEPEGAWAIAN_PEGAWAI_IPASN:
            return {
                ...state,
                listsIPASN: action.payload
            }
        case GET_LIST_KEPEGAWAIAN_PEGAWAI_PRIBADI:
            return {
                ...state,
                listsPribadi: action.payload
            }
        case GET_DETAIL_KEPEGAWAIAN_PEGAWAI:
            return {
                ...state,
                detail: action.payload
            }
        case CHANGE_TAB_KEPEGAWAIAN_IPASN:
            return {
                ...state,
                typeIPASN: action.payload
            }
        default:
            return {
                ...state
            }
    }
};

export default kepegawaianReducer